import { Add } from "@mui/icons-material"
import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { arrayPush } from "redux-form"

const useRoleBtn = () => {
    const dispatch = useDispatch()

    const addRole = useCallback(() => {
        alert("ממתין לפיתוח - מחכה לUI מתהילה")
        // dispatch(arrayPush("createUser", 'roles', {}))
    }, [])

    const roleBtn = {
        label: "הוספת תפקיד",
        icon: <Add />,
        action: addRole,
        size: "small",
        color: "thirdly"
    }

    return roleBtn
}

export default useRoleBtn